import { HttpErrorResponse } from "@angular/common/http";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { sntTranslate } from "src/app/support/translate";

export function isCustomerNotBillableError(error: unknown): boolean {
  const httpErrorResponse = error as HttpErrorResponse;

  if (httpErrorResponse.status !== 409) {
    return false;
  }

  return httpErrorResponse.error?.code === "409.8";
}

export function getCustomerNotBillableErrorMessage(): string {
  return sntTranslate(
    marker(
      "Impossibile fatturare: l'anagrafica cliente selezionata non è più disponibile."
    )
  );
}

export function getInvoiceCreateErrorMessage(error: unknown): string {
  if (isCustomerNotBillableError(error)) {
    return getCustomerNotBillableErrorMessage();
  }

  return sntTranslate(marker("Impossibile creare la fattura"));
}
